/* ============
 * Create Page
 * ============
 *
 * This is the page for adding news.
 */
import moment from 'moment';
import newsService from './../../../../services/news';
import campaignService from './../../../../services/campaign';
import newsTransformer from './../../../../transformers/news';
import Forms from './../../../../utils/forms/forms';

export default {
  data() {
    return {
      form: new Forms({
        subject: {
          value: '',
          type: 'text',
        },
        sendAfterDate: {
          value: '',
          type: 'date',
        },
        sendAfterTime: {
          value: '',
          type: 'time',
        },
        sendAfter: {
          value: '',
          type: 'number',
        },
        body: {
          value: '',
          type: 'editor',
        },
        newsCampaignId: {
          value: this.$route.params.id,
          type: 'hidden',
        },
      }),
      campaign: {},
      loading: true,
      sending: false,
    };
  },

  created() {
    campaignService.show(this.$route.params.id).then((campaign) => {
      this.loading = false;
      this.campaign = campaign;
      if (campaign.campaignType === 'Sequence') {
        this.form.hideField('sendAfterDate');
        this.form.hideField('sendAfterTime');
      } else {
        this.form.hideField('sendAfter');
      }
    });
  },

  methods: {
    /**
     * Method to store the news.
     */
    store() {
      this.form.loading = true;
      const data = this.form.data();
      data.sendAfterDate = data.sendAfterDate ?
      `${moment(data.sendAfterDate).format('YYYY-MM-DD')} ${data.sendAfterTime}` : '';
      const news = newsTransformer.send(data);
      newsService.store(news)
      .catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    /**
     * Send test email.
     */
    test() {
      this.sending = true;
      newsService.test(newsTransformer.send(this.form.data()))
      .then(() => {
        this.sending = false;
        this.$message({
          showClose: true,
          message: this.$t('static.news.create.sendTestSucess'),
          type: 'success',
        });
      }).catch((error) => {
        this.sending = false;
        if (error.response.data) {
          this.form.recordErrors(newsTransformer.fetch(error.response.data));
        }
      });
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/news/create/create.js